import type { FlowVariant } from './types';

export const DEFAULT_FLOW_VARIANT: FlowVariant = 'new-program';

export const MAX_COLLECTIONS_PER_PROGRAM = 10;
export const MAX_LEARNING_PATHS_PER_PROGRAM = 10;
